// PlannerContent Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import $ from 'jquery'

import PlannerItem from '../planner_item/planner_item.jsx'
import PlannerItemDate from '../planner_itemdate/planner_itemdate.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class PlannerContent extends Component {
  static get propTypes () {
    return {
      items: PropTypes.array,
      filter: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      items: null,
      filter: null
    }
  }

  constructor (props) {
    super(props)

    this.data = {
      totalRangeDays: this._getTotalRanges(props.filter)
    }

    this._resizeHandler = this._resize.bind(this)
  }

  componentDidMount () {
    $(window).on('resize', this._resizeHandler)
    this._updateColumnMinHeight()
  }

  componentWillUnmount () {
    $(window).off('resize', this._resizeHandler)
  }

  componentDidUpdate () {
    this._updateColumnMinHeight()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps.filter, this.props.filter)) {
      this.data.totalRangeDays = this._getTotalRanges(nextProps.filter)
    }
  }

  render () {
    return (
      <div className='reportplanner-content'>
        <div className='colleft'>
          {this.props.items.map((item, idx) => (
            <PlannerItem
              key={idx}
              item={item}
              index={idx}
              onChange={this._onChange.bind(this)}
            />
          ))}
        </div>
        <div
          className={`colright${
            this.props.filter.filterType === 'week' ? ' colright-week' : ''
          }`}
        >
          {this._renderLines()}
          {this.props.items.map((item, idx) => (
            <PlannerItemDate
              key={idx}
              item={item}
              index={idx}
              totalRangeDays={this.data.totalRangeDays}
            />
          ))}
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChange () {
    this.setState({ dataDate: new Date() })
  }

  _resize () {
    window.setTimeout(this._updateColumnMinHeight.bind(this), 100)
  }

  _updateColumnMinHeight () {
    const contOuterHeight = $('.page-header.planner')
      .eq(0)
      .outerHeight()
    const minHeight = $(window).height() - contOuterHeight

    $('.reportplanner-content .colleft, .reportplanner-content .colright').css(
      'min-height',
      `${minHeight}px`
    )
  }

  /* Private functions */
  _getTotalRanges (filter) {
    if (!filter) return []

    let totalRangeDays = 4 * 7
    const fromDate = new Date(filter.fromDate)
    if (filter.filterType === 'half-year') {
      totalRangeDays = 0
      let startdate = fromDate
      for (let idx = 1; idx <= 6; idx++) {
        totalRangeDays += this._getLastDateOfMonth(startdate)
        startdate = new Date(startdate.getYear(), startdate.getMonth() + 1, 1)
      }
    }

    return totalRangeDays
  }

  _getLastDateOfMonth (date) {
    return new Date(date.getFullYear(), date.getMonth(), 0).getDate()
  }

  _renderLines () {
    const lines = []
    let itemWidth = 16.66
    let totalItems = 7

    // For week mode
    if (!this._isFilterMonth()) {
      itemWidth = 25
      totalItems = 5
    }

    const startDate = new Date(this.props.filter.fromDate)
    let totalPosLeft = 0
    const totalRangeDays = this._getTotalRanges(this.props.filter)
    for (let idx = 0; idx <= totalItems; idx++) {
      let posLeft = itemWidth * idx
      if (this._isFilterMonth() && idx > 0) {
        const prevMonthTotalDays = new Date(
          startDate.getFullYear(),
          startDate.getMonth(),
          0
        ).getDate()
        posLeft = totalPosLeft + (prevMonthTotalDays / totalRangeDays) * 100

        totalPosLeft = posLeft
      }

      lines.push({
        posLeft: posLeft
      })

      startDate.setMonth(startDate.getMonth() + 1)
    }

    return (
      <div className='lineswrap'>
        {lines.map((line, idx) => (
          <div
            key={idx}
            className={`lineitem item_${idx}`}
            style={{ left: `${line.posLeft}%` }}
          />
        ))}
        {!this._isFilterMonth() &&
          _.range(7 * 4).map(idx => {
            const day = DateUtil.addDaysToDate(startDate, idx).getDay()
            const left = day === 0 ? 3.57 : 7.14
            let perc = 25
            if (idx > 6 && idx < 14) {
              perc = 50
            } else if (idx > 13 && idx < 21) {
              perc = 75
            } else if (idx > 20 && idx < 28) {
              perc = 100
            }
            if (day === 0 || day === 6) {
              return (
                <div
                  key={idx}
                  className={`weekenditem weekenditem_${idx}`}
                  style={{ left: `${perc - left}%` }}
                />
              )
            }

            return null
          })}
      </div>
    )
  }

  _isFilterMonth () {
    return this.props.filter.filterType === 'half-year'
  }
}

export default PlannerContent
